document.addEventListener('DOMContentLoaded', function () {
    if (window.reviews && Array.isArray(window.reviews)) {
        var allReviews = window.reviews;
        var reviewsPerPage = 10;
        var currentReviewIndex = 0;
        var storageKey = window.location.pathname + "-reviews"; // Einzigartiger Schlüssel basierend auf der URL
        var maxLength = 150; // Maximale Länge der Kommentare, bevor "Weiter lesen" angezeigt wird

        // Funktion, um Bewertungen zufällig auszuwählen
        function getRandomReviews(reviews, num) {
            var shuffled = reviews.sort(() => 0.5 - Math.random());
            return shuffled.slice(0, num);
        }

        // Funktion, um Bewertungen in LocalStorage zu speichern
        function storeReviews(key, reviews) {
            localStorage.setItem(key, JSON.stringify(reviews));
        }

        // Funktion, um Bewertungen aus LocalStorage zu holen
        function loadStoredReviews(key) {
            var storedReviews = localStorage.getItem(key);
            return storedReviews ? JSON.parse(storedReviews) : null;
        }

        var selectedReviews = loadStoredReviews(storageKey);
        if (!selectedReviews) {
            selectedReviews = getRandomReviews(allReviews, allReviews.length); // Alle Bewertungen mischen
            storeReviews(storageKey, selectedReviews);
        }

        // Funktion zum Anzeigen von Bewertungen
        function displayReviews(reviews) {
            var reviewsContainer = document.getElementById('reviews-container');
            var endIndex = currentReviewIndex + reviewsPerPage;
            var reviewsToDisplay = reviews.slice(currentReviewIndex, endIndex);

            reviewsToDisplay.forEach(function (review) {
                var reviewElement = document.createElement('div');
                reviewElement.className = 'single-review';
                
                // Überprüfe, ob die Länge des Kommentars das Limit überschreitet
                var reviewText = review.review;
                var shortText = reviewText.length > maxLength ? reviewText.substring(0, maxLength) + "..." : reviewText;
                var fullTextVisible = false;

                reviewElement.innerHTML = `
                    <div class="review-header">
                        <span class="review-name">${review.name}</span>
                        <span class="review-date">${new Date(review.date).toLocaleDateString()}</span>
                    </div>
                    <div class="review-rating">
                        ${generateStars(review.rating)}
                        <span class="rating-text">${review.rating}.0 von 5</span>
                    </div>
                    <div class="review-comment">
                        <p class="review-text">${shortText}</p>
                        ${reviewText.length > maxLength ? '<a href="#" class="read-more-link">Weiter lesen</a>' : ''}
                    </div>
                `;
                reviewsContainer.appendChild(reviewElement);

                // Event-Listener für "Weiter lesen"
                if (reviewText.length > maxLength) {
                    var readMoreLink = reviewElement.querySelector('.read-more-link');
                    readMoreLink.addEventListener('click', function (e) {
                        e.preventDefault();
                        if (!fullTextVisible) {
                            reviewElement.querySelector('.review-text').innerHTML = reviewText; // HTML wird interpretiert
                            readMoreLink.innerText = 'Weniger lesen';
                            fullTextVisible = true;
                        } else {
                            reviewElement.querySelector('.review-text').innerHTML = shortText; // HTML wird interpretiert
                            readMoreLink.innerText = 'Weiter lesen';
                            fullTextVisible = false;
                        }
                    });
                }
            });

            currentReviewIndex += reviewsPerPage;

            // Button ausblenden, wenn keine weiteren Bewertungen mehr verfügbar sind
            if (currentReviewIndex >= reviews.length) {
                document.getElementById('load-more-reviews').style.display = 'none';
            }
        }

        // Funktion, um Sterne zu generieren
        function generateStars(rating) {
            var starHTML = '';
            for (var i = 1; i <= 5; i++) {
                if (i <= rating) {
                    starHTML += '<span class="star-icon filled"></span>';
                } else {
                    starHTML += '<span class="star-icon"></span>';
                }
            }
            return starHTML;
        }

        // Initial erste 10 Bewertungen anzeigen
        displayReviews(selectedReviews);

        // Event-Listener für den "Weitere Bewertungen anzeigen"-Button
        var loadMoreButton = document.getElementById('load-more-reviews');
        loadMoreButton.addEventListener('click', function () {
            displayReviews(selectedReviews);
        });

    } else {
        console.error("Keine Bewertungen gefunden oder das reviews Array ist nicht geladen.");
    }
});
